var LocalizationManager = require('../Managers/LocalizationManager.js');

export function sanitizePhoneNumber(phoneNumberString)
{
	return phoneNumberString;
}

export function deserializeArguments(argArray)
{
	var obj = {};
	for( var i = 0; (i+1) < argArray.length; i += 2 ) obj[argArray[i]] = argArray[i+1];

	return obj;
}

export function serializeArguments(argObj)
{
	var argString = "";
	for( var key in argObj ) argString += "/" + key + "/" + argObj[key];

	return argString;
}

export function stringPhoneValue(phoneRaw)
{
  return phoneRaw;
  
  // kelsey: removing phone number formatting for now. we may add this back in
	// var phoneRaw = phoneRaw + "             ";
 //  	var formattedPhone = phoneRaw.substring(0, 1) 
 //  		+ " (" 
 //  		+ phoneRaw.substring(1, 4) 
 //  		+ ") " 
 //  		+ phoneRaw.substring(4, 7) 
 //  		+ "-"
 //  		+ phoneRaw.substring(7, 11);
  	
 //  	return formattedPhone;
}

export function findGetParameter(parameterName) 
{
  var result = null, tmp = [];
  window.location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });

  return result;
}

export function pts(numPts, completion)
{
  LocalizationManager.localizedStringForKey("PTS_CONTEXTUAL", [numPts], (translatedString) =>
  {
    completion(translatedString)
  });
  
}

export function points(numPoints, completion)
{
  LocalizationManager.localizedStringForKey("POINTS_CONTEXTUAL", [numPoints], (translatedString) =>
  {
    completion(translatedString)
  });
}

export function isRetail() 
{
  return true;//findGetParameter("isRetail") == "1";
}

export function getReturnURL()
{
  return findGetParameter("returnURL");
}

export function getSaleID()
{
  return findGetParameter("saleID");
}

export function getCustomerID()
{
  var customerID = findGetParameter("customerID");
  return customerID > 0 ? customerID : -1;
}

export function getShopID()
{
  return findGetParameter("shopID");
}

export function getAccountID()
{
  return findGetParameter("accountID");
}

export function getComponent()
{
  return findGetParameter("_component");
}

export function getURLInputs()
{
  let mobile = isMobile();

  return {returnURL:getReturnURL(), saleID:getSaleID(), customerID:getCustomerID(), shopID:getShopID(), accountID:getAccountID(), mobile};
}

export function isMobile()
{
  // return true;
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

  return check;
}

export function setCookie(name,value,days) 
{
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export function getCookie(name) 
{
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

export function eraseCookie(name) 
{   
    document.cookie = name+'=; Max-Age=-99999999;';  
}

export function getEnvironmentString()
{
    if( document.URL.indexOf("loyalty-retail.lightspeedappstg") > -1 )
    {
      return 'stage.';
    } else if( document.URL.indexOf("loyalty-retail.feature01.getreup") > -1 )
    {
      return 'feature01.';
    }
    else if( document.URL.indexOf("loyalty-retail.feature02.getreup") > -1 )
    {
      return 'feature02.';
    }
    else if( document.URL.indexOf("localhost") > -1 )
    {
      return 'dev.';
    }
    return '';
}

export function getURL() {
  return window.location.href;
}